import { render, staticRenderFns } from "./Cm24Article.vue?vue&type=template&id=576a211e&scoped=true"
import script from "./Cm24Article.vue?vue&type=script&lang=js"
export * from "./Cm24Article.vue?vue&type=script&lang=js"
import style0 from "./Cm24Article.vue?vue&type=style&index=0&id=576a211e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576a211e",
  null
  
)

export default component.exports